import Line from "../../Line";
import {GRAMMAR, STATE, BLOCK} from "../../Type";
import {Block, Sprite, Property, Action, Util} from "../index";

export class GameObject extends Block {
  get type() {
    return "GameObject";
  }

  get category() {
    return "GameObject";
  }

  getGrammarFor(parent) {
    if (parent instanceof Line) {
      return GRAMMAR.SUBJECT;
    } else {
      return GRAMMAR.OBJECTIVE;
    }
  }

  getDefaultChildren() {
    if (this.grammar === GRAMMAR.SUBJECT) {
      return [new Block({state: STATE.INSTANCE, parent: this})];
    } else {
      return [];
    }
  }

  static getPrototypeBlocks(gameObjects) {
    const prototypeBlocks = [];

    for (let i in gameObjects) {
      prototypeBlocks.push(Sprite.getPrototypeBlock(gameObjects[i]));
    }

    // for (let i in gameObjects) {
    //   const gameObject = gameObjects[i];
    //   let prototypeBlock;
    //   switch (gameObject.type) {
    //     case "sprite":
    //     case "spine":
    //     case "custom":
    //     case "Group": // TODO:
    //       prototypeBlock = Sprite.getPrototypeBlock(gameObject);
    //       break;
    //     case "text":
    //       prototypeBlock = Text.getPrototypeBlock(gameObject);
    //       break;
    //     case "component":
    //       if(gameObject.subtype === "dpad") {
    //         prototypeBlock = DPad.getPrototypeBlock(gameObject);
    //       } else {
    //         prototypeBlock = Joystick.getPrototypeBlock(gameObject);
    //       }
    //       break;
    //     case "background":
    //       prototypeBlock = Screen.getPrototypeBlock(gameObject);
    //       break;
    //     case "sound":
    //       prototypeBlock = Sound.getPrototypeBlock(gameObject);
    //       break;
    //     default:
    //       continue;
    //   }
    //   prototypeBlocks.push(prototypeBlock);
    // }
    return prototypeBlocks;
  }

  getAvailableChildTypesAt(index) {
    if (this.grammar === GRAMMAR.SUBJECT) {
      return [Property, Action, Util];
    } else if (this.grammar === GRAMMAR.OBJECTIVE) {
      return [Property, Util];
    } else {
      return [];
    }
  }

  // toJavascript() {
  //   if (this.grammar === GRAMMAR.SUBJECT) {
  //     const child = this.children[0];
  //     const childCode = child.toJavascript();
  //     return `this.getSprite("${this.data}")${childCode}`;
  //   } else if (this.grammar === GRAMMAR.OBJECTIVE) {
  //     const child = this.children && this.children[0];
  //     if (child) {
  //       const childCode = child.toJavascript();
  //       return `this.getSprite("${this.data}")${childCode}`;
  //     } else {
  //       if(this.parent.type === BLOCK.ACTION && this.parent.data === "set") {
  //         return `this.getSprite("${this.data}")`;
  //       } else {
  //         return `"${this.data}"`;
  //       }
  //     }
  //   }
  // }

  toJavascript() {
    if (this.grammar === GRAMMAR.SUBJECT) {
      const child = this.children[0];
      const childCode = child.toJavascript();
      return `this.getSprite("${this.uuid}")${childCode}`;
    } else if (this.grammar === GRAMMAR.OBJECTIVE) {
      const child = this.children && this.children[0];
      if (child) {
        const childCode = child.toJavascript();
        return `this.getSprite("${this.uuid}")${childCode}`;
      } else {
        if (this.parent.type === BLOCK.ACTION && this.parent.data === "set") {
          return `this.getSprite("${this.uuid}")`;
        } else {
          return `"${this.uuid}"`;
        }
      }
    }
  }
}
